"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=fin-department-revenue-mapping.dto.js.map